






















import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import { Location, Locations, emptyLocation } from "@/models/GeoLocation.ts";
import Map from "./Map.vue";

@Component({ components: { Map } })
export default class GeoLocation extends Vue {
  @Prop({ type: Object, default: () => ({ ...emptyLocation }) })
  value!: Locations;

  get headers() {
    return [
      { text: "#", sortable: false },
      { text: "Name", value: "name" },
      { text: "Accuracy", value: "accuracy" },
      { text: "Actions", sortable: false },
    ];
  }

  get computedLocations() {
    return this.value.locations;
  }

  get computedMarkers() {
    const locations = this.value.locations || [];
    return locations.map((location: any, i: number) => ({
      id: i,
      position: {
        lat: location.latlng[0],
        lng: location.latlng[1],
      },
    }));
  }

  remove(index: number) {
    console.log(`remove: ${index}`);
    let locations = this.value.locations.filter((_, i) => i !== index);
    let centroid: number[] = [];
    let location = { centroid, locations };
    console.log(location);
    this.$emit("input", location);
  }
}
